import type { SVGProps } from 'react'
const FishHoghooghiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 210 210"
    {...props}
  >
    <g filter="url(#Fish_Hoghooghi_svg__a)">
      <rect
        width={144}
        height={144}
        x={32.801}
        y={23.6}
        fill="#fff"
        rx={30.29}
      />
      <path
        fill="#C8D3F7"
        d="M98.043 135.237c-7.521-1.326-11.281-1.989-12.944-6.223-1.662-4.234-.578-10.386 1.592-22.69l1.534-8.7c2.17-12.303 3.254-18.455 6.265-21.865s6.77-2.747 14.291-1.421l21.272 3.75c7.521 1.327 11.281 1.99 12.943 6.224 1.663 4.234.578 10.386-1.591 22.689l-1.534 8.7c-2.17 12.304-3.255 18.456-6.265 21.866s-6.771 2.747-14.291 1.421z"
      />
      <path
        fill="#2852E4"
        fillRule="evenodd"
        d="m94.897 132.526 32.827-11.948c4.941-1.799 7.453-7.396 5.605-12.473l-11.978-32.908c-1.598-4.392-5.941-6.98-10.278-6.443a1 1 0 0 0-.218.053L79.392 80.26c-.935.34-1.978-.165-2.329-1.128-.35-.964.124-2.021 1.059-2.362l30.525-11.11c.562-.204.846-.839.636-1.417l-1.139-3.129c-.853-2.341-2.67-4.13-4.987-4.911-2.312-.779-4.78-.434-6.77.95L69.684 75.803c-2.624 1.81-3.672 5.233-2.543 8.336l15.445 42.435c1.849 5.077 7.374 7.749 12.312 5.952"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={3.125}
        d="m95.338 114.849 19.693-7.181M91.57 104.515l19.693-7.18M87.8 94.18 107.495 87"
      />
    </g>
    <defs>
      <filter
        id="Fish_Hoghooghi_svg__a"
        width={209.028}
        height={209.028}
        x={0.287}
        y={0.461}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={9.375} />
        <feGaussianBlur stdDeviation={16.257} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_7632" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_7632"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default FishHoghooghiIcon
